import React from "react";
import { agoLine } from "@/lib/stages";
import { ukDayTime } from "@/lib/time";

const DAY = 86400000;

/** The latest real move on a case or lane — the dot breathes while it is under a day old. */
export function LiveLine({ move, testId }) {
  if (!move?.text || !move?.at) return null;
  const fresh = Date.now() - new Date(move.at).getTime() < DAY;
  return (
    <div className={`live-line${fresh ? " fresh" : ""}`} data-testid={testId} data-fresh={fresh ? "1" : "0"}
         title={ukDayTime(move.at, "")}>
      <i aria-hidden="true" />
      <span>{move.text} · {agoLine(move.at)}</span>
    </div>
  );
}

export default LiveLine;
